import React from "react";
import {
  Grid,
  Typography,
  Paper,
  TextField,
  InputAdornment,
  Button,
  Checkbox,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import AuthContext from "../../../contexts/AuthContext";
import { login } from "../../../utilities/authFlow";

import "./AuthStyle.css";
import logo from "../../../assets/tnfmlogo.png";

const Login = ({ setPage }) => {
  const theme = useTheme();
  const { setSignedIn, email, setEmail, setTempSession } = React.useContext(AuthContext);
  // const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [passwordVisibility, setPasswordVisibility] = React.useState(false);
  const [rememberMe, setRememberMe] = React.useState(false);
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    const reEmail = localStorage.getItem(
      `${process.env.REACT_APP_COGNITO_CLIENT_ID}.email`
    );
    if (reEmail) {
      setRememberMe(true);
      setEmail(reEmail);
    }
  }, []);

  const handleLogin = async () => {
    const loginResult = await login(email, password);
    if (loginResult.success && loginResult?.newPassword ) {
      setTempSession(loginResult.session);
      setPage('create-new-password');
      return;
    } else if (loginResult.success) {
      setSignedIn(true);
    } else {
      setSignedIn(false);
      setError(loginResult.error)
    }
  };

  const handleRememberMe = () => {
    if (!rememberMe) {
      setRememberMe(true);
      localStorage.setItem(
        `${process.env.REACT_APP_COGNITO_CLIENT_ID}.email`,
        email
      );
    } else {
      setRememberMe(false);
      localStorage.removeItem(
        `${process.env.REACT_APP_COGNITO_CLIENT_ID}.email`
      );
    }
  };

  return (
    <Grid
      container
      spacing={3}
      justifyContent="center"
      style={{
        height: '100%',
        backgroundColor: "#cfc9bc",
        fontFamily: "Instrument Sans, sans-serif",
      }}
    >
      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <img src={logo} height="150px" />
        <Typography variant="h6">The Next Fun <span style={{color:'#e6ff02'}}>Match</span></Typography>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        lg={5}
        style={{ display: "flex", justifyContent: "center" }}
      >
        {/* <form style={{ display: "flex", justifyContent: "center" }}> */}
        <Paper
          elevation={3}
          style={{ width: "100%", padding: 10, backgroundColor: "#11190c" }}
        >
          <Grid container direction="column" spacing={3}>
            <Grid item style={{ marginTop: 20, marginBottom: 20 }}>
              <Typography
                variant="h5"
                align="center"
                style={{ color: "#ffffff" }}
              >
                Sign into your account
              </Typography>
            </Grid>
            {error ? (
              <Grid item style={{ display: "flex", justifyContent: "center" }}>
                <Typography
                  variant="subtitle2"
                  style={{ color: "#e6ff02", paddingLeft: 20 }}
                >
                  {error}
                </Typography>
              </Grid>
            ) : (
              <></>
            )}
            <Grid item style={{ display: "flex", justifyContent: "center" }}>
          
              <div style={{ width: "90%" }}>
                <label
                  htmlFor="email-input"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: 12,
                    color: "#fff",
                    fontSize: "0.9rem",
                  }}
                >
                  Email / Username
                </label>
                <input
                  id="email-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  className="authInput"
                />
              </div>
            </Grid>
            <Grid item style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ width: "90%", position: "relative" }}>
                <label
                  htmlFor="password-input"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: 12,
                    color: "#fff",
                    fontSize: "0.9rem",
                  }}
                >
                  Password
                </label>
                <input
                  id="password-input"
                  type={passwordVisibility ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Your password"
                  className="authInput"
                  style={{
                    paddingRight: "40px", // leave space on the right for the eye icon
                  }}
                  autoComplete="off"
                />
                <div
                  onClick={() => setPasswordVisibility(!passwordVisibility)}
                  style={{
                    position: "absolute",
                    right: 16,
                    top: 52,
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#fff",
                  }}
                >
                  {passwordVisibility ? <VisibilityOff /> : <Visibility />}
                </div>
              </div>
            </Grid>

            <Grid
              item
              style={{
                paddingTop: 0,
                // paddingLeft: "52px",
                marginBottom: -10,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Checkbox
                style={{ paddingLeft: 44 }}
                size="small"
                checked={rememberMe}
                onChange={handleRememberMe}
                sx={{
                  color: "#838383",
                  "&.Mui-checked": {
                    color: '#838383'
                  },
                }}
              />
              <Typography variant="subtitle2" style={{ color: "#ffffff" }}>
                Remember me?
              </Typography>
            </Grid>
            <Grid item style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                style={{
                  width: "90%",
                  height: 40,
                  backgroundColor: "#e6ff02",
                  color: "#252b20",
                }}
                onClick={handleLogin}
              >
                Sign in
              </Button>
            </Grid>

            <Grid item style={{ display: "flex", justifyContent: "center" }}>
              <Button
                style={{
                  width: "90%",
                  height: 40,
                  color: "#e6ff02",
                }}
                onClick={() => setPage("forgot")}
              >
                reset password
              </Button>
            </Grid>
            <Grid item style={{ marginTop: 0, marginBottom: 0 }}>
              <Typography
                variant="subtitle2"
                align="center"
                style={{ paddingLeft: 10, paddingRight: 10, color: 'white' }}
              >
                Don't have an account? Click{" "}
                <span
                  onClick={() => window.open("https://thenextfunmatch.com", "_blank")}
                  style={{
                    color: "#e6ff02",
                    cursor: "pointer",
                  }}
                >
                  here
                </span>{" "}
                to get in touch.
              </Typography>
            </Grid>
          </Grid>
        </Paper>
        {/* </form> */}
      </Grid>
      <Grid item xs={12}>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <Typography align="center" style={{ color: "#353535" }}>
              &copy; Aisle 2 LLC All Rights Reserved
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              align="center"
              style={{ color: "#353535", marginBottom: 50, cursor: "pointer" }}
              // onClick={() => window.open(appConfig?.privacyPolicy, "_blank")}
            >
              Privacy Policy
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>

    // <div style={{ display: "flex", flexDirection: "column", alignItems: 'center' }}>
    //   <div>
    //     <img src={Logo} height="200px" />
    //   </div>
    //   <div>
    //     <Paper elevation={3} style={{ width: '100%', height: 400, padding: 10 }}>
    //       <Grid container direction="column">
    //         <Grid item>
    //           <Typography>Sign into your account</Typography>
    //         </Grid>
    //       </Grid>
    //     </Paper>
    //   </div>
    //   <div>
    //     bottom
    //   </div>
    // </div>
  );
};

export default Login;
